export const NO_EMAIL_OWNER = 'unassigned'

export const CONTROLS_INDEX_PAGE_SIZE = 20
